import { render, staticRenderFns } from "./Moderator.vue?vue&type=template&id=2e166eb1&"
import script from "./Moderator.vue?vue&type=script&lang=js&"
export * from "./Moderator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports